import { SplitTreatments } from "@splitsoftware/splitio-react";
import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import rentingBenefitImageV2 from "../../../../../assets/img/v2/renting-benefit.png";
import BenefitCard from "../../BenefitCard";
import featureFlagsDictionary from "../../../../../infrastructure/split/feature-flags-dictionary";
import { BenefitCategory } from "../../../../../v2/domain/common/entities/BenefitCagetory";
import { CountryIsoCode } from "../../../../../v2/domain/common/enums/CountryISOCode";

const RentingTab = ({
  selectedTab,
  toggleActive,
  country,
  companyId,
}: {
  selectedTab: { id: string; rentingBenefit: any };
  toggleActive: (id: string, benefit: string) => void;
  country: CountryIsoCode;
  companyId: string;
}) => {
  return (
    <SplitTreatments
      names={[featureFlagsDictionary.BI_264]}
      attributes={{
        companyId,
        countryISOCode: country,
        benefit: BenefitCategory.RENTING,
      }}
    >
      {({ treatments, isReady }) => {
        const isActiveTreatment =
          treatments[featureFlagsDictionary.BI_264].treatment === "on";

        const benefitProps =
          isReady && isActiveTreatment
            ? {
                hasV2Screen: true,
                handleSeeMore: () =>
                  window.location.assign(
                    `/v2/benefits/compensation-plan/${selectedTab.id}/renting?tab=information`
                  ),
              }
            : {
                tooltipText: t(
                  "benefits-section.renting-benefit.benefit-model-tooltip"
                ),
                handleActiveToggle: () =>
                  toggleActive(selectedTab.id, "rentingBenefit"),
              };

        return (
          <BenefitCard
            benefit={BenefitTypeEnum.RENTING_BENEFIT}
            title={t("common-messages.renting")}
            image={rentingBenefitImageV2}
            active={selectedTab.rentingBenefit}
            country={country}
            {...benefitProps}
          />
        );
      }}
    </SplitTreatments>
  );
};

export default RentingTab;
